import { BrandUtil } from 'dw-us-ui';

const brand = BrandUtil.getBrand();
const brandTag = BrandUtil.content(brand).tag.toLowerCase();

const brandSpaceIDMap = {
	wsj: 'm1b7s66kk1b9', // us-wsj
	npr: '6rxbwdlytrj8', // us-npr
	law: 'pcz1l1qufd2i', // us-law
	osw: '2z1yjaidgv67', // us-osw
	tcm: 'pcz1l1qufd2i', // us-tcm
	fox: '1nwewppcllht', // us-fox aka us-wlb
	bon: '9q3prfdsy8fi', // us-bon aka us-bat
};
const brandAccessToken = {
	wsj: {
		developmentToken: 'YJsEIjwwgMRwIqtQGOi0DjVMm5WjzmXjTbs2X4Vjf-Q',
		productionToken: 'GRCsvI733yQ0vO1524fUInLCTGbB3-k_oGG0U8NF27g',
	}, // us-wsj
	npr: {
		developmentToken: 'rZmgIN1XXvaK8gNyfPzDCeDc8_h2mY4ZTnH3Euqsh9Y',
		productionToken: 'PMnkPCQ8QG4FEDj7ermSE5YmPzuc1HTfdWlxwhv1hcY',
	}, // us-npr
	law: {
		developmentToken: 'k6aCVfg9F-Sm6S2Gv2lpUwxkGg_yArH1oNVtdIgtkNA',
		productionToken: 'a_PJJkskgCDQlffRHqnqEBSMyomH04SdXDwfEbcN6sE',
	}, // us-law
	osw: {
		developmentToken: 'blarUaSCQiRcnrpaDr8PaMj1UBkq4q1Xaw76XNx7KK8',
		productionToken: 'q6cj3VQBgpvNhlvsXQfkVP2-Hwz5IyXjMR-zBmwBndA',
	}, // us-owa
	tcm: {
		developmentToken: 'k6aCVfg9F-Sm6S2Gv2lpUwxkGg_yArH1oNVtdIgtkNA',
		productionToken: 'GRCsvI733yQ0vO1524fUInLCTGbB3-k_oGG0U8NF27g',
	}, // us-tcm
	fox: {
		developmentToken: 'bamw0Mu4IkJVv0Qdut2b9cHWtr8QZatXvTxEqI61cX8',
		productionToken: 'bamw0Mu4IkJVv0Qdut2b9cHWtr8QZatXvTxEqI61cX8',
	}, // us-fox
	bon: {
		developmentToken: '8O3iy21eZd-zU32Pe2anXBPBY76p_HNVfCH2Fck9l80',
		productionToken: 'I2bqpKej5IqPE-dCB5zFj3wyC97isXdz1fd-k13cuOU',
	}, // us-bon
};

export const selectedSpaceID = brandSpaceIDMap[brandTag] || 'pcz1l1qufd2i'; // Provide a fallback

export const getAccessToken = () => {
	const url = window.location.href;

	switch (true) {
		case url.includes('.uat'):
			return brandAccessToken[brandTag]['developmentToken'];
		case url.includes('.st'):
			return brandAccessToken[brandTag]['developmentToken'];
		case url.includes('www') || url.includes('preview'):
			return brandAccessToken[brandTag]['productionToken'];
		default:
			return brandAccessToken[brandTag]['productionToken'];
	}
};
